
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23 12c0 3.038-1.231 5.788-3.222 7.779l-1.414-1.414A8.972 8.972 0 0021 12a8.972 8.972 0 00-2.636-6.364l1.414-1.414A10.966 10.966 0 0123 12z"}}),_c('path',{attrs:{"d":"M19.5 12c0 2.072-.84 3.947-2.197 5.304L15.89 15.89A5.483 5.483 0 0017.5 12a5.483 5.483 0 00-1.61-3.888l1.413-1.414A7.477 7.477 0 0119.5 12zM8.697 17.304l1.414-1.414A5.483 5.483 0 018.5 12c0-1.518.616-2.893 1.61-3.888L8.698 6.698A7.477 7.477 0 006.5 12c0 2.07.84 3.946 2.197 5.303z"}}),_c('path',{attrs:{"d":"M5 12a8.972 8.972 0 012.636-6.363L6.222 4.223A10.966 10.966 0 003 12c0 3.037 1.231 5.787 3.222 7.778l1.414-1.414A8.972 8.972 0 015 12z"}}),_c('circle',{attrs:{"cx":"13","cy":"12","r":"2"}})])
          )
        }
      }
    